









































import DraftElement from '@/builder/sections/mixins/DraftElement'
import mixins from 'vue-typed-mixins'

export default mixins(DraftElement).extend({
  name: 'AppFooterSignature',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    date: new Date().getFullYear()
  }),
  computed: {
    socialMedia (): Record<string, any> {
      return [
        { icon: '$facebook', link: this.data.configuration.wb_facebook__url__, extraClass: 'social-icon-scale' },
        { icon: '$instagram', link: this.data.configuration.wb_instagram__url__, extraClass: 'social-icon-scale' },
        { icon: '$youtube', link: this.data.configuration.wb_youtube__url__, extraClass: 'social-icon-scale' },
        { icon: '$x', link: this.data.configuration.wb_twitter__url__, extraClass: 'social-icon-scale' },
        { icon: '$linkedin', link: this.data.configuration.wb_linkedin__url__, extraClass: '' },
        { icon: '$tiktok', link: this.data.configuration.wb_tiktok__url__, extraClass: 'social-icon-scale' }
      ]
    }
  }
})
